import { createSingularSetup } from '@scouts/singular'

import config from '@/config'
import { CURRENCY } from './constants'

/**
 * Create Singular setup with app-specific configuration
 * Uses the factory function to eliminate duplication
 */
const singularSetup = createSingularSetup({
    sdkKey: config.singularSdkKey,
    sdkSecret: config.singularSdkSecret,
    productId: config.singularProductId,
    isProduction: config.isProduction,
    defaultCurrency: CURRENCY,
    revenueEventName: 'paymentSuccess', // Configurable revenue event name
    isRevenueEvent: (eventName: string) => {
        // Check if event name contains 'purchase' to identify revenue events
        return eventName.includes('purchase')
    },
})

export const { config: singularConfig, shouldInitializeSingularWeb, handleSingularError } = singularSetup
